import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import AlignmentTick from 'search/blast/AlignmentTick';
import {AlignmentConstants} from 'search/blast/constants';

export interface GraphAlignmentRulerProps {
  scale: number; // per-base length in pixel
  sequenceLength: number;
  isCompact: boolean;
}

const TICK_MIN_DISTANCE = 75;
const BASE_TICK_INTERVALS: Array<number> = [5, 10, 25];

/**
 * Pick an interval that separates two adjacent ticks
 * at least TICK_MIN_DISTANCE pixels apart.
 */
const getTickInterval = (scale: number): number => {
  let factor = 1;
  let interval = BASE_TICK_INTERVALS[0];
  while (interval * scale < TICK_MIN_DISTANCE) {
    for (const baseInterval of BASE_TICK_INTERVALS) {
      interval = baseInterval * factor;
      if (interval * scale >= TICK_MIN_DISTANCE) {
        return interval;
      }
    }
    factor *= 10;
  }
  return interval;
};

/**
 * Return 0-based sequence positions.
 */
const getTicks = (sequenceLength: number, tickInterval: number): Array<number> => {
  const ticks: Array<number> = [];
  for (let position = tickInterval; position < sequenceLength; position += tickInterval) {
    ticks.push(position);
  }
  return ticks;
};

export default function GraphAlignmentRuler(props: GraphAlignmentRulerProps): JSX.Element {
  const tickInterval = getTickInterval(props.scale);
  const ticks: Array<number> = getTicks(props.sequenceLength, tickInterval);

  return (
    <div className={css(styles.tickRow, props.isCompact && styles.compactTickRow)}>
      {ticks.map((tick, index) => (
        <div key={index} style={{position: 'absolute', left: `${tick * props.scale}px`, top: '0px'}}>
          <AlignmentTick tick={tick} isCompact={props.isCompact} />
        </div>
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  tickRow: {
    height: AlignmentConstants.tickHeight.normal,
  },
  compactTickRow: {
    height: AlignmentConstants.tickHeight.compact,
  },
});
